var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isOpen)?_c('VBlock',{attrs:{"id":"toast-layer","padding":[0, 38, 0, 38]}},[_c(_vm.name,{tag:"component",attrs:{"text":_vm.text}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }